import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import { companyInfo } from "../data/companyData";
import "./LegalPages.css";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" updated="January 2026">
      <section className="legal-block">
        <h2>1. Introduction</h2>
        <p>
          Quinterra Software Solutions Pvt. Ltd. (&quot;Quinterra&quot;, &quot;we&quot;, &quot;us&quot;, or
          &quot;our&quot;) operates AI-powered SaaS products including Hr-Assist, Qshikshak, and related
          platforms. This Privacy Policy explains how we collect, use, disclose, and safeguard your
          information when you visit our website or use our services.
        </p>
      </section>

      <section className="legal-block">
        <h2>2. Information We Collect</h2>
        <p>
          We may collect personal information such as name, email address, phone number, company
          details, and usage data when you contact us, register for our products, or interact with
          our platforms. We also collect technical data including IP address, browser type, and
          device information.
        </p>
      </section>

      <section className="legal-block">
        <h2>3. How We Use Your Information</h2>
        <p>
          We use collected information to provide and improve our SaaS products, respond to inquiries,
          process transactions, send service-related communications, ensure platform security, and
          comply with legal obligations.
        </p>
      </section>

      <section className="legal-block">
        <h2>4. Data Storage &amp; Security</h2>
        <p>
          Data is stored on secure cloud infrastructure including AWS services. We implement
          industry-standard security measures including encryption, access controls, and regular
          security reviews to protect your information.
        </p>
      </section>

      <section className="legal-block">
        <h2>5. Third-Party Services</h2>
        <p>
          We may use third-party service providers for analytics, cloud hosting, email delivery, and
          payment processing. These providers are bound by confidentiality agreements and process data
          only as instructed by us.
        </p>
      </section>

      <section className="legal-block">
        <h2>6. Your Rights</h2>
        <p>
          You may request access to, correction of, or deletion of your personal data by contacting us
          at{" "}
          <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>. We will respond to valid
          requests within a reasonable timeframe.
        </p>
      </section>

      <section className="legal-block">
        <h2>7. Contact</h2>
        <p>
          {companyInfo.legalName}
          <br />
          {companyInfo.address}
          <br />
          Email: <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
          <br />
          Phone: <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}>{companyInfo.phone}</a>
        </p>
      </section>
    </LegalPageLayout>
  );
}
